'use strict';

var DashDialogsActions = function DashDialogsActions (Flux, APP_DISPATCHER_ID) {

  var Actions = Flux.Actions.create('DashDialogsActions', APP_DISPATCHER_ID);

  Actions.add({
    name: 'SubscriptionExpired',
    purpose: 'Display Dialog blocking the project due to an expired subscription',
    payload: ['site', 'organization']
  });

  Actions.add({
    name: 'NoDataCaptureAvailable',
    purpose: 'Attempted to export a datacapture with none available',
    payload: []
  });

  Actions.add({
    name: 'NotSupportedInPlanWarning',
    purpose: 'The Plan governing this feature doesn\'t have access to this feature',
    payload: []
  });

  Actions.add({
    name: 'SiteSlugChanged',
    purpose: 'Notify users that the map they are seeing has changed its URL and invite them to refresh with new URL',
    payload: ['site']
  });

  Actions.add({
    name: 'SiteDeleted',
    purpose: 'Notify users that the map they are seeing has been deleted',
    payload: ['site']
  });

  return Actions;
};

DashDialogsActions.$inject = ['sbFlux', 'APP_DISPATCHER_ID'];
module.exports = DashDialogsActions;



// WEBPACK FOOTER //
// ./src/app/dash/dialogs/DashDialogsActions.js